var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedPolygon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 40,
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 39.7113C18.1906 39.89 17.8094 39.89 17.5 39.7113L1.17949 30.2887C0.87009 30.11 0.679488 29.7799 0.679488 29.4227L0.679487 10.5774C0.679487 10.2201 0.870084 9.88996 1.17949 9.71133L17.5 0.288679C17.8094 0.110044 18.1906 0.110044 18.5 0.288675L34.8205 9.71132C35.1299 9.88996 35.3205 10.2201 35.3205 10.5774L35.3205 29.4226C35.3205 29.7799 35.1299 30.11 34.8205 30.2887L18.5 39.7113Z",
    fill: "#A90821"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedPolygon);
export default __webpack_public_path__ + "static/media/RedPolygon.e8bb248e.svg";
export { ForwardRef as ReactComponent };